import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { Card, Row, Col, Typography, Layout, theme, Grid } from 'antd';
import AppHeader from '../layout/AppHeader';
import i18n from "../../i18n/config";
import { useTranslation } from 'react-i18next';


const { Meta } = Card;
const { Title } = Typography;

const Academy: React.FC = () => {
   const screens = Grid.useBreakpoint();
  const isMobile = !screens.lg;
  const [videos, setVideos] = useState<any[]>([]);
  const { token } = theme.useToken();
  const { t, i18n } = useTranslation();
    const LANGUAGE = i18n.resolvedLanguage || i18n.language;

  useEffect(() => {
    const fetchVideos = async () => {
      const academyRef = collection(db, 'academy');
      const academyQuery = query(academyRef, orderBy('order', 'asc'));
      const academySnapshot = await getDocs(academyQuery);
      const videoData = academySnapshot.docs.map((doc) => doc.data());
      setVideos(videoData);
    };
    fetchVideos();
  }, []);

  return (
    <Layout style={{ display: 'flex', flexDirection: 'column', minHeight: '100svh', background: token.colorBgBase }}>
       <AppHeader position={isMobile ? 'fixed' : 'sticky'} />

      <Row style={{ flex: 1, overflow: 'hidden' }}>
        <Col span={24} style={{ height: '100%' }}>
          <div style={{ overflowY: 'auto', height: '100%', padding: 25, paddingTop: isMobile ? 75 : 25, paddingBottom: 80 }}>
            <Title level={2} style={{marginTop: isMobile ? '0px' : '50px'}}>{t("academy.title")}</Title>
            <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
              {videos.map((video, index) => (
                <Col key={index} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    hoverable
                    cover={
                      <iframe
                        src={video.url}
                        title={video.title[i18n.language]}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        style={{ height: 300, width: '100%', border: 0 }}
                      />
                    }
                  >
                    <Meta title={video.title[i18n.language]} />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default Academy;
